/* global Qtip, MyWindow, Loc, MyFacture, MyForm, Utils */

window.Snippet = {
	
	remove : function(id){
        return new Promise((resolve, reject) => {

            var msg = Loc.g('Êtes-vous sûr de vouloir supprimer le widget Sellsy?');
            var options = {
                type		: "warning",
                resizable	: false,
                noclose		: true,
                title		: Loc.g("Suppression"),
                buttons		: [
                    {
                        text	: Loc.g("Non"),
                        click	: function(){
                            $(this).dialog("close");
                        }
                    },
                    {
                        text	: Loc.g("Oui"),
                        click	: function(){

                            let popup = $(this);
                            MyFacture.post("prefsSnippet", { action : "delete", id : id }, function(data){
                                popup.dialog("close");
                                data.deleted ? resolve(data) : reject(data);
                            }, "json");

                        }
                    }
                ]
            };

            MyWindow.alert(msg, options);
        });
	},
	
	prepareForm : function(snippetID){
		
		snippetID = (snippetID === undefined ? 0 : snippetID);
		
		var _this	= this;
		var formID	= 'snippetForm';
		
		var options = {
			title	: snippetID == 0 ? Loc.g('Créer un widget Sellsy') : Loc.g('Modifier le widget Sellsy'),
			buttons	: [
                {
                    text	: Loc.g("Annuler"),
                    click	: function() {
                        $(this).dialog("close");
                    }
                },
                {
					text	: Loc.g("Enregistrer"),
					click	: function() {
						$("#" + formID).submit();
					}
				}
			],
			width		: 1200,
			callback	: function() {
				
				var options = {
					success		: function(data) {
						
						if(MyForm.processJson(data, formID)){
							Utils.reload();
						}
						
					},
					dataType	: "json",
					data		: { action : "record" }
				};
				
				MyForm.prepare(formID, 'prefsSnippet', options, true);
				MyFacture.customForm('#' + formID);
				
				var v_form = $('#' + formID);
				
				$(':input:not([type=hidden]):first', v_form).focus();
				
				var v_features = $('#snippet_features', v_form);
				v_features.multipleSelect({
					
					placeholder	: Loc.g("Choisissez les fonctionnalités que vous souhaitez utiliser"),
					width		: 300,
					selectAll	: false,
					countSelected : false,
					selectAllText: Loc.g('Tout Sélectionner'),
					allSelected: Loc.g('Tous sélectionnés'),
					
					onClick: function(option) {
						
						switch(option.value){
							
							case 'tracking':
								_this.toggleTrackingPart.call(_this, option);
								break;
							
							case 'email':
								_this.toggleMailPart.call(_this, option);
								break;
									
							case 'prospection':
								_this.toogleProspectionPart.call(_this, option);
								break;
								
							case 'support':
								_this.toogleSupportPart.call(_this, option);
								break;
							
						}
						
					}
					
				});
				
				var v_pictureUsage = $('#snippet_pictureUsage', v_form);
				v_pictureUsage.multipleSelect({
					
					placeholder	: Loc.g("Choisissez les emplacements où inclure l‘avatar"),
					width		: 300,
					selectAll	: false,
					countSelected : false
					
				});
				
				$('#snippet_funnel', v_form).on('change', _this.loadSteps.bind(_this));
				$('input[name="snippet_includeStaffPicture"]', v_form).on('change', _this.toggleStaffPicture.bind(_this));
				
				var v_displayMode = $('input[name="snippet_displayMode"]', v_form);
				v_displayMode.on('change', _this.toggleUsageOption.bind(_this));
				v_displayMode.filter(':checked').trigger('change');
				
				var v_availableFieldsSelects = $('#availableFields-container select', v_form);
				v_availableFieldsSelects.on('change', _this.toggleTextPlaceholder.bind(_this));
				v_availableFieldsSelects.trigger('change');
				
				_this.toggleTrackingPart({
					checked : $('option[value="tracking"]', v_features).is(':selected')
				});
				
				_this.toggleMailPart({
					checked : $('option[value="email"]', v_features).is(':selected')
				});
				
				_this.toogleProspectionPart({
					checked : $('option[value="prospection"]', v_features).is(':selected')
				});
				
				_this.toogleSupportPart({
					checked : $('option[value="support"]', v_features).is(':selected')
				});
				
				_this.toggleStaffPicture({
					currentTarget : $('input[name="snippet_includeStaffPicture"]:checked', v_form)
				});
				
				Qtip.init();
				
			}
		};
		
		MyWindow.load("prefsSnippet", { action : "getRecordForm", snippetid : snippetID }, options);
		
	},
	
	toggleTextPlaceholder : function(event){
		
        var v_select	= $(event.currentTarget);
        var closest     = '.form-group';
        var linked      = v_select.data('linked');

        // If you want to hide/show another block just add it to the condition and add a parent div with class 'form-block'
        if (linked == 'campaign'){
            closest = '.form-block';
        }

        var v_toToggle = $('#snippet_' + v_select.data('linked') + 'PlaceholderText').closest(closest);
        
		if(v_select.val() == 'hide'){
			v_toToggle.hide();
		}else{
			v_toToggle.show();
		}
		
	},
	
	toggleUsageOption : function(event){
		
		var v_displayMode		= $(event.currentTarget);
		var v_select			= $('#snippet_pictureUsage');
		var v_optionToToggle	= $('option[value=bubble]', v_select);
		
		if(v_displayMode.val() == 'tab'){
			v_optionToToggle.prop('selected', false).prop('disabled', true);
		}else{
			v_optionToToggle.prop('disabled', false);
		}
		
		v_select.multipleSelect('refresh');
		
	},
	
	toggleStaffPicture : function(event){
		
		var v_launcher		= $(event.currentTarget);
		var v_staffGroup	= $('#pictureStaff_formGroup');
		var v_usageGroup	= $('#pictureUsage_formGroup');
		
		if(v_launcher.val() == 'Y'){
			
			v_staffGroup.show();
			v_usageGroup.show();
			
		}else{
			
			v_staffGroup.hide();
			v_usageGroup.hide();
			
		}
		
	},
	
	loadSteps : function(event){
		
		var v_funnel	= $(event.currentTarget);
		var v_steps		= $('#snippet_step');
		
		MyFacture.post('prospection_opportunity', 
			{
				action		: 'getStepsForFunnel',
				funnelid	: v_funnel.val()
			},
			
			function(data){
				
				v_steps.empty();
				for(var i in data.steps){
					v_steps.append('<option value="' + data.steps[i].id + '">' + data.steps[i].rank + " - " + data.steps[i].label + ' (' + data.steps[i].proba + '%)</option>');
				}
//				v_steps.selectmenu();
				
			},
			
		'json');
		
	},
	
	mainToogle : function(v_object, option){
		
		if(option.checked){
			v_object.show();
		}else{
			v_object.hide();
		}
		
	},
	
	toggleMailPart : function(option){
		this.mainToogle($('#emailPart'), option);
	},
	
	toogleProspectionPart : function(option){
		
		var v_toToggle = $('#snippet_prospectionRequestText').closest('.form-group');
		if(option.checked){
			v_toToggle.show();
		}else{
			v_toToggle.hide();
		}
		
		this.mainToogle($('#prospectionPart'), option);
	},
	
	toogleSupportPart : function(option){
		
		var v_toToggle = $('#snippet_supportRequestText').closest('.form-group');
		if(option.checked){
			v_toToggle.show();
		}else{
			v_toToggle.hide();
		}
		
		this.mainToogle($('#supportPart'), option);
	},
	
	toggleTrackingPart : function(option){
		this.mainToogle($('#trackingPart'), option);
	},	
};

window.SnippetTab = {
	
	loadMore: function(linkedtype, linkedid){

		if (!$('#snippetTrackingMore').hasClass('wait')){
			
			var _page = parseInt($('#snippetTrackingMore').attr('page'));
			$('#snippetTrackingMore').addClass('wait');
			$('#snippetTrackingMore').attr('page', _page+1);
			
			var options = {
				action			: "loadMorSnippetrackingTab",
				linkedtype		: linkedtype,
				linkedid		: linkedid,
				page			: _page
			};
			
			MyFacture.post('prefsSnippet', options, function (data) {
				
				$('#content_snippetracking .snippetTrackingEntries').append(data.html);
				if (data.noMoreElement == 'Y'){
					$('#snippetTrackingMore').remove();
				} else {
					$('#snippetTrackingMore').removeClass('wait');
				}
				
			}, 'json');
			
			
		}
		
		
	},
	
};